"use client";

import { type KeyboardEvent, useEffect } from "react";
import { isArray, isWindowDefined } from "@huub-web/utils";

export const useKeys = (key: string | string[], fn: () => void) => {
  useEffect(() => {
    if (!isWindowDefined()) {
      return;
    }

    const handleKeyUp = (e: Event) => {
      const keyboardEvent = e as unknown as KeyboardEvent;

      if (
        isArray(key)
          ? key.includes(keyboardEvent.key)
          : keyboardEvent.key === key
      ) {
        fn();
      }
    };

    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);
};
